define('responsive-game-feed/app/scripts/views/GameOver',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','Autolinker.js/dist/Autolinker.min','gameday-language/gameday-language'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var autoLinker  = require("Autolinker.js/dist/Autolinker.min");
    var gamedayLanguage = require("gameday-language/gameday-language");
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function GameOverView(cfg) {
       this.element = cfg.element;
    }

    GameOverView.prototype = {

      render: function(cfg) {
               var template = hogan.compile(cfg.template); 
               var model = cfg.model;
               var away_score = model.data.away_score * 1;
               var home_score = model.data.home_score * 1;
               var win_score;
               var los_score;
               var winTeam ={};
               var losTeam ={};
               var wpData = {};
               var lpData = {};
               var svData = {};
               var win_teamname;
               var los_teamname;
               var that = this;
               
               if (away_score > home_score) {
                 win_score  = away_score;
                 los_score  = home_score;
                 win_teamname = model.data.away_team_abbrev;
                 los_teamname = model.data.home_team_abbrev;
               } else {
                 win_score  = home_score;
                 los_score  = away_score;
                 win_teamname = model.data.home_team_abbrev;
                 los_teamname = model.data.away_team_abbrev;
               }
               
               winTeam.score = win_score;
               losTeam.score = los_score;
               
               winTeam.name = win_teamname;
               losTeam.name = los_teamname;
               
               wpData.name = model.data.wp.boxname;
               wpData.player_id = model.data.wp.player_id;
               
               if ( model.data.wp.wins &&  model.data.wp.losses) {
                 wpData.score = model.data.wp.wins +"-"+ model.data.wp.losses;
               }
               
               
               lpData.name = model.data.lp.boxname;
               lpData.player_id = model.data.lp.player_id;
               
                if ( model.data.lp.wins &&  model.data.wp.losses) {
                 lpData.score = model.data.lp.wins +"-"+ model.data.lp.losses;
               }
               
               
               
               if (model.data.sv && model.data.sv.boxname) {
                 svData.name = model.data.sv.boxname;
               }
               
                if (model.data.sv && model.data.sv.player_id) {
                 svData.player_id = model.data.sv.player_id;
               }
              
             
               model.winTeam = winTeam;
               model.losTeam = losTeam;
               model.wpData = wpData;
               model.lpData = lpData;
               model.svData = svData;
               
               var currentNodeId = cfg.model.guid;
               var html = template.render({
                  model : model, 
                  mustacheLanguage : gamedayLanguage(Utils.options.language)
                });
                
               
               Utils.insertItem(this.element,model,html);       
               
               this.element.find("#"+currentNodeId).find(".teams-result a").on("click", function(e) {
                 Utils.sendPlayerMessage.call(this, {target: $(this), event:e});
               }); $(cfg.feedView).trigger("renderCBTracker_"+currentNodeId, currentNodeId);
            
         
        }
       
   };    

    return GameOverView;

});
